
























import { Component, Prop, Vue } from 'vue-property-decorator';
import { NetworkUptimeReport } from '@/types';
import SectionHeader from '@/components/SectionHeader.vue';
import BaseStationReport from '@/components/reports/BaseStationReport.vue';

@Component({
  components: {
    SectionHeader,
    BaseStationReport
  },
})
export default class GeneratedReport extends Vue {
  
  @Prop({ default: () => {},  type: Object}) report!: NetworkUptimeReport;
  
  mounted() {
    
  }
  
}
